<template>
  <div class="sub-menu-gift-wrapping sub-menu">
    <!-- Content -->
    <div
      v-if="content?.giftWrapping?.text"
      class="sub-menu-gift-wrapping__text"
    >
      <span v-html="content?.giftWrapping?.text" />
    </div>

    <responsive-image
      v-if="content?.giftWrapping?.image"
      :image="{
        url: content?.giftWrapping.image
      }"
      min-max="423-332"
      sizes="423px"
      lazyload
    />

    <!-- Links content -->
    <div
      v-if="createLinks.length"
      class="sub-menu-gift-wrapping__links"
    >
      <clickable-list
        ref="giftWrappingLinks"
        display-icons
        :links="createLinks"
        @mouseleave="resetList"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Sub menu delivery
 * -----------------------------------------------------------------------------
 * Delivery & returns sub menu component.
 *
 * @param {Object} content - Content to be displayed.
 *
 */

import ClickableList from '~global/clickable-list/clickable-list'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'SubMenuGiftWrapping',

  components: {
    ClickableList,
    ResponsiveImage,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Builds a list of links to be fed into a clickable-list component.
     * @returns {Array}
     */
    createLinks() {
      return []
    },
  },

  methods: {

    /**
     * Resets the linklist in the component on mouseleave.
     */
    resetList() {
      const links = this.$refs.giftWrappingLinks

      if (!links) {
        return
      }

      links.resetComponentData()
    },
  },
}
</script>
